import { LeftMenu, NavigationItemParams } from '@store/App/LeftMenu';
import { AuthUser } from '@store/AuthUser/AuthUser';

const CLINICS_NAV_LINK = '/clinics';

interface Params {
    authUser: AuthUser;
    leftMenu: LeftMenu;
    hasClinicsAccess: boolean;
    isNonProdEnv: boolean;
}

export function buildNavigationItems({
    authUser,
    leftMenu,
    hasClinicsAccess,
    isNonProdEnv,
}: Params): NavigationItemParams[] {
    let navigationItems = collectItemsByRoles({ authUser, leftMenu });

    if (isNonProdEnv && !authUser.isDirector) {
        navigationItems = [...navigationItems, ...leftMenu.notificationItems];
    }

    if (!hasClinicsAccess) {
        navigationItems = navigationItems.filter(item => item.link !== CLINICS_NAV_LINK);
    }

    return navigationItems;
}

function collectItemsByRoles({ authUser, leftMenu }: Pick<Params, 'authUser' | 'leftMenu'>): NavigationItemParams[] {
    const navigationItems: NavigationItemParams[] = [];

    if (authUser.isAccountant || authUser.hasRootAccess) {
        navigationItems.push(...leftMenu.accountantItems);
    }

    if (authUser.hasRootAccess) {
        navigationItems.push(...leftMenu.items, ...leftMenu.rootAccessItems);
    } else if (authUser.isDirector) {
        navigationItems.push(...leftMenu.items, ...leftMenu.directorItems);
    } else if (authUser.isAssistant) {
        navigationItems.push(...leftMenu.items, ...leftMenu.assistantItems);
    } else if (authUser.isDoctor || !authUser.isAccountant) {
        navigationItems.push(...leftMenu.items);
    }

    if (authUser.isDoctor) {
        navigationItems.push(...leftMenu.getDocrotItem(authUser.id));
    }

    return navigationItems;
}
